import { DEFAULT_CURRENCY_FORMATTER } from "@redotech/money/util";
import {
  VariantStockStatus,
  type BackInStockVariantDetail,
} from "@redotech/redo-customer-common/customer-product-notification/customer-product-notification";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { StandardRedoTableHeaderCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-header-cells";
import { Flex } from "@redotech/redo-web/flex";

export const VARIANT_TABLE_LAYOUT = {
  columns: [
    {
      widthMode: { type: "fill" as const },
      renderHeaderCell: () =>
        StandardRedoTableHeaderCell({ headerText: "Variant" }),
      renderNormalCell: ({ row }: { row: BackInStockVariantDetail }) => (
        <RedoTableTextCell text={row.title} />
      ),
    },
    {
      widthMode: { type: "fill" as const },
      renderHeaderCell: () =>
        StandardRedoTableHeaderCell({ headerText: "SKU" }),
      renderNormalCell: ({ row }: { row: BackInStockVariantDetail }) => (
        <RedoTableTextCell text={row.sku} />
      ),
    },
    {
      widthMode: { type: "fill" as const },
      renderHeaderCell: () =>
        StandardRedoTableHeaderCell({ headerText: "Status" }),
      renderNormalCell: ({ row }: { row: BackInStockVariantDetail }) => (
        <Flex p="xl">
          <RedoBadge
            color={
              row.status === VariantStockStatus.IN_STOCK ? "success" : "error"
            }
            text={
              row.status === VariantStockStatus.IN_STOCK
                ? "In stock"
                : "Out of stock"
            }
          />
        </Flex>
      ),
    },
    {
      widthMode: { type: "fill" as const },
      renderHeaderCell: () =>
        StandardRedoTableHeaderCell({ headerText: "Waiting" }),
      renderNormalCell: ({ row }: { row: BackInStockVariantDetail }) => (
        <RedoTableTextCell text={row.waitingCount.toString()} />
      ),
    },
    {
      widthMode: { type: "fill" as const },
      renderHeaderCell: () =>
        StandardRedoTableHeaderCell({ headerText: "Price" }),
      renderNormalCell: ({ row }: { row: BackInStockVariantDetail }) => (
        <RedoTableTextCell
          text={DEFAULT_CURRENCY_FORMATTER.format(row.price)}
        />
      ),
    },
  ],
  headerColor: "white" as const,
};
